import { DataProvider } from '@/common/models';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetQuery } from '@/org-app/services/tanstack/queryUtils';

export const useDataProviders = createGetQuery<DataProvider>(
  [queryKeys.dataProviders],
  (qp) => {
    return OrgAppAPIProxy.instance.getDataProviders(qp);
  },
  {},
);
